import React from 'react';
import PropTypes from 'prop-types';

import Layout from '../../components/Layout';

import ImprintTemplate from '../../templates/Imprint';

const Imprint = ({ pageContext, data }) => {
  const {
    markdownRemark: { frontmatter }
  } = data;
  const { language } = pageContext;
  const { pageTitle, ...pageContent } = frontmatter;

  return (
    <Layout language={language} pageTitle={pageTitle} activePage="/impressum">
      <ImprintTemplate {...{ ...pageContent, language }} />
    </Layout>
  );
};

Imprint.propTypes = {
  pageContext: PropTypes.shape({
    language: PropTypes.string.isRequired
  }).isRequired,
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({
        pageTitle: PropTypes.string.isRequired,
        contact: PropTypes.object.isRequired,
        operator: PropTypes.object.isRequired,
        copyright: PropTypes.object.isRequired,
        responsible: PropTypes.object.isRequired,
        euSettlement: PropTypes.object.isRequired,
        header: PropTypes.object.isRequired,
        titleSection: PropTypes.object.isRequired,
        liabilityForContent: PropTypes.object.isRequired,
        liabilityForLinks: PropTypes.object.isRequired,
        universalSettlement: PropTypes.object.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};

export default Imprint;
